// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/feed/components/FeedCreatorMark.module.css';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {useId} from 'react';

export const CONTENT_CREATOR_DESCRIPTOR = msg({
	message: 'Content creator',
	comment:
		'Tooltip and screen reader label of the small mark beside the name of a feed post author who holds the content creator badge (Discover and Reels). Keep it concise.',
});

// Micup akis-v3: beside the author's name on Keşfet and Reels posts (FeedPostResponse.author_creator). The badge family's
// language at 16px: a free silhouette (a rounded play shape) in one hue's vertical gradient, a soft lit top edge for the
// matte relief, and a small white spark on its upper right.
export function FeedCreatorMark({className}: {className?: string}) {
	const {i18n} = useLingui();
	const gradientId = `feed-creator-${useId().replace(/[^\w-]/g, '')}`;
	const label = i18n._(CONTENT_CREATOR_DESCRIPTOR);
	return (
		<Tooltip text={label} data-flx="feed.feed-creator-mark.tooltip">
			<span
				className={clsx(styles.mark, className)}
				role="img"
				aria-label={label}
				data-flx="feed.feed-creator-mark.mark"
			>
				<svg viewBox="0 0 16 16" className={styles.glyph} aria-hidden data-flx="feed.feed-creator-mark.glyph">
					<defs>
						<linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
							<stop offset="0" style={{stopColor: 'var(--feed-creator-top)'}} />
							<stop offset="1" style={{stopColor: 'var(--feed-creator-bottom)'}} />
						</linearGradient>
					</defs>
					<path
						d="M4.25 3.6v8.8l8.05-4.4z"
						fill={`url(#${gradientId})`}
						stroke={`url(#${gradientId})`}
						strokeWidth="3.4"
						strokeLinejoin="round"
					/>
					<path
						d="M4.6 4.2l5.9 3.2"
						fill="none"
						stroke="#fff"
						strokeOpacity="0.38"
						strokeWidth="0.9"
						strokeLinecap="round"
					/>
					<path d="M7.4 4.5l.42 1.28 1.28.42-1.28.42-.42 1.28-.42-1.28-1.28-.42 1.28-.42z" fill="#fff" />
				</svg>
			</span>
		</Tooltip>
	);
}
